import { SearchTerritoryType } from 'generated/graphql'
import { GLOBAL_TAXONOMY_TERRITORY_TYPES } from 'modules/global-topic/common/global-topic.consts'

export const COMPARE_TOPICS_FILTER_KEYS = [
  'savedPostSearches',
  'subtopics',
  'topics',
  'niches',
  'tags',
  'industry_topic',
  'global_topic',
  ...GLOBAL_TAXONOMY_TERRITORY_TYPES,
]

export const SEARCH_TERRITORY_COMPARE_TAKE = 5

export const SEARCH_TERRITORY_COMPARE_TYPES: readonly SearchTerritoryType[] = [
  SearchTerritoryType.Theme,
  SearchTerritoryType.Segment,
  SearchTerritoryType.Subject,
  SearchTerritoryType.Entity,
  SearchTerritoryType.OwnedTopic,
]
